import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { COLORS, FONTS } from '../theme';
import { FACILITIES, BUBBLES } from '../data/siteData';
import { Section, SectionHeading, Reveal, Icon, Wave, float } from './common';

export default function Facilities() {
  return (
    <Section id="facilities" bg="#fff" sx={{ pt: { xs: 4, md: 6 } }}>
      <Container maxWidth="lg">
        <SectionHeading
          eyebrow="Why Parents Love Us"
          title="Everything Your Child Needs to Bloom"
          subtitle="Safe spaces, healthy food, loving teachers and joyful activities, all under one roof."
          color={COLORS.green}
        />

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }, gap: 3 }}>
          {FACILITIES.map((f, i) => (
            <Reveal key={f.title} direction={i % 2 ? 'right' : 'left'} delay={(i % 3) * 120} sx={{ height: '100%' }}>
              <Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  gap: 2.2,
                  alignItems: 'flex-start',
                  p: 3,
                  borderRadius: '28px',
                  bgcolor: f.bg,
                  border: `3px solid ${f.color}33`,
                  transition: 'transform .3s ease, box-shadow .3s ease, border-color .3s',
                  '&:hover': { transform: 'translateY(-8px) scale(1.02)', boxShadow: `0 18px 34px ${f.color}40`, borderColor: f.color, '& .fac-icon': { transform: 'rotate(360deg) scale(1.1)' } },
                }}
              >
                <Box className="fac-icon" sx={{ flexShrink: 0, width: 64, height: 64, borderRadius: '50%', bgcolor: '#fff', color: f.color, boxShadow: `0 6px 0 ${f.color}55`, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'transform .7s ease' }}>
                  <Icon name={f.icon} sx={{ fontSize: 34 }} />
                </Box>
                <Box>
                  <Typography variant="h5" sx={{ fontSize: 21, color: f.color, lineHeight: 1.15 }}>{f.title}</Typography>
                  <Typography sx={{ mt: 1, fontSize: 15, lineHeight: 1.65, color: COLORS.text }}>{f.text}</Typography>
                </Box>
              </Box>
            </Reveal>
          ))}
        </Box>

        <Box sx={{ mt: { xs: 8, md: 11 }, textAlign: 'center' }}>
          <Reveal>
            <Typography variant="h3" sx={{ fontSize: { xs: 28, md: 38 }, color: COLORS.navy }}>
              A week full of{' '}
              <Box component="span" sx={{ color: COLORS.pink }}>joyful</Box>{' '}
              <Box component="span" sx={{ color: COLORS.blue }}>activities</Box>
            </Typography>
          </Reveal>
          <Box sx={{ mt: 4, display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: { xs: 1.5, md: 2.2 } }}>
            {BUBBLES.map((b, i) => (
              <Reveal key={b.label} direction="zoom" delay={i * 90} duration={600}>
                <Box
                  sx={{
                    px: { xs: 2.5, md: 3.5 },
                    py: { xs: 1.2, md: 1.6 },
                    borderRadius: 50,
                    bgcolor: b.color,
                    color: b.color === COLORS.yellow ? COLORS.navy : '#fff',
                    fontFamily: FONTS.heading,
                    fontWeight: 800,
                    fontSize: { xs: 16, md: 20 },
                    boxShadow: `0 7px 0 ${b.color}88`,
                    animation: `${float} ${4 + (i % 4)}s ease-in-out ${i * 0.3}s infinite`,
                    cursor: 'default',
                  }}
                >
                  {b.label}
                </Box>
              </Reveal>
            ))}
          </Box>
        </Box>
      </Container>
      <Wave color={COLORS.sky} sx={{ mt: 6, mb: '-2px' }} />
    </Section>
  );
}
